import Link from 'next/link';
import PriceHeader from './PriceHeader';
import { ResolutionData } from '@/lib/tradingview/chartData';
import { CurrentPrice } from '@/components/charts/PortfolioChart';
import { IUserERC20Balance } from '@/hooks/portfolio/useERC20Balance';
const TotalPortfolioLink = ({
  assetData,
  currentPrice,
  currentResolution
}: {
  assetData: IUserERC20Balance;
  currentPrice: CurrentPrice;
  currentResolution: ResolutionData;
}) => {
  return <div className='flex items-center justify-between mx-4' data-sentry-component="TotalPortfolioLink" data-sentry-source-file="TotalPortfolioLink.tsx">
      <Link href='/overview' className='w-full' data-sentry-element="Link" data-sentry-source-file="TotalPortfolioLink.tsx">
        <PriceHeader currentResolution={currentResolution} currentPrice={currentPrice} assetData={assetData} data-sentry-element="PriceHeader" data-sentry-source-file="TotalPortfolioLink.tsx" />
      </Link>
    </div>;
};
export default TotalPortfolioLink;